module.exports = ['$rootScope', '$timeout', '$window', function ($rootScope, $timeout, $window) {
    return {
        restrict: 'E',
        scope: true,
        replace: true,
        controller: ["$scope", function ($scope) {


            $scope.showCommentForm = false;
            $scope.fullFeed = [];
            $scope.showFullFeed = false;

            $scope.logLimit = function () {
                return $scope.showFullFeed ? $scope.fullFeed.length : 3;
            };

            $scope.toggleFullFeed = function () {
                $scope.showFullFeed = !$scope.showFullFeed;
            };

            $scope.feedToggleTitle = function () {
                return $scope.showFullFeed ? "Show latest" : "Show all";
            };

            $scope.getMessageHtml = function (message) {
                var link = `<a ng-click="openOrderDialog({order_id: ${message.order_request}, type: 'request', close_only: true, can_edit: false})" href="" class="btn-link">order request</a>`
                return message.template
                    .replace(/\$from_user/g, message.from_user)
                    .replace(/\$order_request/g, link);
            };

            $scope.toggleCommentForm = function () {
                $scope.showCommentForm = !$scope.showCommentForm;
            };

            $scope.$watch("order", function (newVal, oldVal) {
                if (newVal.id > 0) {
                    mapFeed(newVal);
                }
            });

            function mapFeed(order) {
                // create feed messages
                order.feed.forEach(function (item, index) {
                    $scope.fullFeed.push(item);
                });
            }

        }],
        templateUrl: '/static/partials/order_feed.html',
        link: function ($scope, $element, attrs) {

        }
    };
}];